const villa_sec3Object = (payload) => {
  return {
    type: "villasec3",
    payload,
  };
};

export default villa_sec3Object;
